import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useNavigate, useParams} from "react-router-dom";
import {Tag} from "primereact/tag";
import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";
import Btn from "../../../ui/Btn";
import MemberModal from "./MemberModal";
import PageLayout from "../../PageLayout";

const ShowTeam = () => {
    const {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        clubStore.getTeam(id);
    }, [id]);

    const TeamMember = ({member}) => {
        const companyUser = member.company_user;
        const isTrainer = companyUser.role?.id === "TRN";
        const isHeadCoach = member.data?.head_coach === true;

        return (
            <div className="grid secondary-card">
                <div className="col-12">
                    <div className="flex justify-content-between align-items-start gap-2">
                        <div className="flex-1">
                            <div className="flex align-items-center flex-wrap gap-2">
                                <b className="text-lg">{companyUser.title}</b>
                                {isTrainer && (
                                    <Tag
                                        severity={isHeadCoach ? "success" : "info"}
                                        icon={isHeadCoach ? "pi pi-star-fill" : "pi pi-star"}
                                        value={isHeadCoach ? appStore.tr.head_coach : appStore.tr.assistant_coach}
                                    />
                                )}
                            </div>

                            {!isTrainer && (
                                <div className="flex flex-wrap gap-2 mt-2">
                                    {!!companyUser.forma_number && (
                                        <Tag value={`#${companyUser.forma_number}`} severity="success"/>
                                    )}
                                    {!!companyUser.year_born && (
                                        <Tag value={companyUser.year_born} severity="info"/>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex mt-3">
                        {isTrainer && (
                            <Btn
                                icon={isHeadCoach ? "pi pi-star-fill" : "pi pi-star"}
                                className="mr-2"
                                outlined
                                severity="success"
                                tooltip={isHeadCoach ? appStore.tr.head_coach : appStore.tr.assistant_coach}
                                onClick={() => {
                                    clubStore.team.toggleHeadCoach(companyUser.id)
                                        .then(() => clubStore.getTeam(id));
                                }}
                            />
                        )}

                        <Btn
                            icon="pi pi-trash"
                            outlined
                            severity="danger"
                            tooltip={appStore.tr.delete}
                            onClick={() => {
                                if (confirm(appStore.tr.are_you_sure_delete)) {
                                    clubStore.deleteTeamMember(member.id);
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <PageLayout
            header={
                <div className="flex justify-content-between align-items-center w-full gap-2">
                    <div>
                        <h3 className="m-0">
                            {clubStore.team.sport?.icon} {clubStore.team.name}
                        </h3>
                        <div className="text-600 mt-1">
                            {appStore.tr.team_members}: {clubStore.team.members?.length || 0}
                        </div>
                    </div>

                    <div className="flex align-items-center gap-2">
                        <MemberModal/>
                        <Btn
                            icon="pi pi-arrow-left"
                            severity="secondary"
                            outlined
                            onClick={() => navigate("/manager/team/list")}
                        />
                    </div>
                </div>
            }
        >
            {clubStore.team.members?.length === 0 && (
                <div className="flex flex-column align-items-center py-5 text-600">
                    <i className="pi pi-users mb-2" style={{fontSize: "2rem"}}/>
                    <span>{appStore.tr.not_found}</span>
                </div>
            )}

            {clubStore.team.members?.map((member) => (
                <TeamMember key={member.id} member={member}/>
            ))}
        </PageLayout>
    );
};

export default observer(ShowTeam);